import { Routes, RouterModule } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';

import { FullComponent } from './layouts/full/full.component';

export const Approutes: Routes = [
	{
		path: '',
		component: BlankComponent,
		children: [
			{ path: '', redirectTo: '/public', pathMatch: 'full' },
			{
				path: 'public',
				loadChildren: './public/public.module#PublicModule'
			}
		]
	},
	{
		path: 'admin',
		component: FullComponent,
		children: [
			{
				path: '',
				loadChildren: './admin/admin.module#AdminModule'
			}
		]
	},
	{
		path: '**',
		redirectTo: '/public/notfound'
	}
];
